// extracted by mini-css-extract-plugin
module.exports = {"label":"communityReactions_label__2Ji-l","row":"communityReactions_row__3540u"};